import minusSvg from '../../../../Assets/Icons/collapse.svg';
import plusSvg from '../../../../Assets/Icons/expandGray.svg';
import styles from './MarginInputsTable.module.scss';

interface IMarginInputsTableCollapsibleFieldProps {
    fieldDisplayName: string | JSX.Element;
    hideGroup: boolean;
    handleCollapse: () => void;
    hideActionButton?: boolean;
}

const MarginInputsTableCollapsibleField: React.FC<IMarginInputsTableCollapsibleFieldProps> = (props: IMarginInputsTableCollapsibleFieldProps) => (
    <div className={styles.margin_inputs_table_collapsible_field}>
        {props.fieldDisplayName}
        {!props.hideActionButton && (
            <button className={styles.margin_inputs_table_collapse_button} type="button" onClick={props.handleCollapse}>
                <img className={styles.margin_inputs_table_image} alt="#" src={props.hideGroup === false ? minusSvg : plusSvg} />
            </button>
        )}
    </div>
);

export default MarginInputsTableCollapsibleField;
